module.exports = __webpack_public_path__ + "static/media/steam.075d5320.svg";